import styled, { css } from 'styled-components';
import { themeGet } from '../v2/foundation/theme/themeGet/get.js';
import { unit, pxToRem, padding, marginBottom } from '../v2/foundation/spacing/utils.js';
import { fontSize } from '../theme/typography/fontSize.js';
import { interactiveTransition } from '../v2/foundation/theme/utils.js';
import { formLabel } from '../theme/typography/styles.js';
import { Button } from '../v2/navigation/buttons/Button/Button.js';

var MAX_WIDTH = 80;
var YEARS_PER_ROW = 5;
var selectedDayStyles = css(["background-color:", ";color:", ";"], themeGet('colors.primary.1000'), themeGet('colors.primary.0'));
var selectedYearStyles = css(["background-color:", ";color:", ";"], themeGet('colors.primary.1000'), themeGet('colors.gray.0'));
var fadedDayStyles = css(["color:", ";"], themeGet('colors.gray.400'));
var todayStyle = css(["background-color:", ";"], themeGet('colors.gray.100'));
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-ejdr2q-0"
})(["display:inline-flex;&:focus-visible{outline:0;}"]);
var Column = styled.div.withConfig({
  displayName: "Column",
  componentId: "sc-ejdr2q-1"
})(["flex:1 1 auto;max-width:", ";"], unit(80));
// Use div container because buttons and flex don't play well together
var DayContainer = styled.div.withConfig({
  displayName: "DayContainer",
  componentId: "sc-ejdr2q-2"
})(["", ";flex:0 0 ", "%;display:flex;justify-content:center;align-items:center;&:before{content:'';padding-top:100%;}"], fontSize('small', '1'), 100 / 7);
var DayButton = styled.button.attrs(function () {
  return {
    type: 'button'
  };
}).withConfig({
  displayName: "DayButton",
  componentId: "sc-ejdr2q-3"
})(["appearance:none;border:none;color:", ";background-color:", ";width:75%;height:75%;border-radius:", ";font-family:inherit;font-size:inherit;", ";", ";", ";", ";&:not(:disabled):focus-visible{outline:0;box-shadow:0 0 0 ", " ", ";}&:not(:disabled):hover{cursor:pointer;color:", ";background-color:", ";", ";}&:disabled{opacity:0.5;}"], themeGet('colors.text.200'), themeGet('colors.gray.0'), themeGet('borderRadius.md'), function (props) {
  return props.$isToday && todayStyle;
}, function (props) {
  return props.$isSelected && selectedDayStyles;
}, function (props) {
  return !props.$isSameMonth && fadedDayStyles;
}, interactiveTransition, pxToRem(3), themeGet('colors.primary.200'), themeGet('colors.text.300'), themeGet('colors.gray.100'), function (props) {
  return props.$isSelected && selectedDayStyles;
});
var HeaderContainer = styled.header.withConfig({
  displayName: "HeaderContainer",
  componentId: "sc-ejdr2q-4"
})(["display:flex;align-items:center;justify-content:space-between;", ";"], padding(3));
var Weekdays = styled.div.withConfig({
  displayName: "Weekdays",
  componentId: "sc-ejdr2q-5"
})(["display:flex;"]);
var Weekday = styled.div.withConfig({
  displayName: "Weekday",
  componentId: "sc-ejdr2q-6"
})(["", ";flex:1 1 ", "%;text-align:center;color:", ";"], formLabel, 100 / 7, themeGet('colors.gray.400'));
var DatePickerBody = styled.main.withConfig({
  displayName: "DatePickerBody",
  componentId: "sc-ejdr2q-7"
})(["display:flex;flex-wrap:wrap;"]);
var YearsList = styled.div.withConfig({
  displayName: "YearsList",
  componentId: "sc-ejdr2q-8"
})(["width:", ";max-height:", ";overflow-y:auto;display:grid;gap:", ";grid-template-columns:repeat(", ",1fr);justify-items:center;align-items:center;", ";"], unit(MAX_WIDTH), unit(MAX_WIDTH * 0.8), unit(1), YEARS_PER_ROW, marginBottom(2));
var YearButton = styled.button.attrs(function () {
  return {
    type: 'button'
  };
}).withConfig({
  displayName: "YearButton",
  componentId: "sc-ejdr2q-9"
})(["appearance:none;border:none;color:", ";background-color:", ";", ";border-radius:", ";font-family:inherit;font-size:inherit;", ";", ";", ";&:not(:disabled):focus-visible{outline:0;box-shadow:0 0 0 ", " ", ";}&:not(:disabled):hover{cursor:pointer;color:", ";background-color:", ";}&:disabled{opacity:0.5;}"], themeGet('colors.text.200'), themeGet('colors.gray.0'), padding(1, 2), themeGet('borderRadius.sm'), function (props) {
  return props.$isThisYear && todayStyle;
}, function (props) {
  return props.$isSelected && selectedYearStyles;
}, interactiveTransition, pxToRem(3), themeGet('colors.primary.200'), themeGet('colors.text.300'), themeGet('colors.gray.100'));
var LayoutHelperButton = styled(Button).attrs({
  type: 'button',
  size: 'small',
  role: 'presentation'
}).withConfig({
  displayName: "LayoutHelperButton",
  componentId: "sc-ejdr2q-10"
})(["visibility:hidden;"]);

export { Column, Container, DatePickerBody, DayButton, DayContainer, HeaderContainer, LayoutHelperButton, Weekday, Weekdays, YEARS_PER_ROW, YearButton, YearsList };
